module.exports = __webpack_public_path__ + "04_glasses_black.f2b13303.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer4/04_glasses_black.png
// module id = mbog
// module chunks = 0